<template>
  <AvatarPrime :image="image" shape="circle" :size="props.size" class="avatar-component" :style="{ '--object-fit': imageFit }"/>
</template>

<script setup>
import {computed} from "vue";
import AvatarPrime from "primevue/avatar";
import AvatarImg from '../assets/images/avatar.svg';

const props = defineProps({
  image: String,
  size: String,
  imageFit : {default: 'contain'},

});

const image = computed(() => props.image || AvatarImg);

</script>

<style lang="scss" scoped>

.avatar-component {
  ::v-deep(img) {
    object-fit: var(--object-fit);
  }
}

</style>
